import { styled } from '@slal/ui';
import { Accordion } from '@slal/ui/display';

export const StyledAccordion = styled(Accordion)`
    border: none;
    border-radius: 0;
    background: none;
    margin: ${({ theme }) => theme.space[6]} 0;

    div {
        padding-left: 0;
        padding-bottom: 0;
        padding-right: 0;
    }

    div[role='button'] {
        border-bottom: 1px solid ${({ theme }) => theme.colors.neutral__light__30};
    }

    h4 {
        font-weight: ${({ theme }) => theme.fonts.sansSerif.fontWeights.regular};
    }
`;
